/** Derived display sections and duration stats for daily views. */
import { useMemo } from 'react';
import {
  getTopActionableTaskId,
  getHeroTask,
  filterOutActiveFocusTask,
  getDailySectionStats,
} from '@/features/tasks/utils/views/dailySectionsUtils';

export function useDailySectionDerived({
  overdueTasks,
  todayTasks,
  upcomingTasks,
  nextActions,
  activeFocusTaskId,
  filteredTasks,
}) {
  const topActionableTaskId = useMemo(
    () => getTopActionableTaskId(overdueTasks, todayTasks, nextActions),
    [overdueTasks, todayTasks, nextActions],
  );

  const heroTask = useMemo(
    () => getHeroTask(activeFocusTaskId, filteredTasks),
    [activeFocusTaskId, filteredTasks],
  );

  const displayOverdueTasks = useMemo(
    () => filterOutActiveFocusTask(overdueTasks, activeFocusTaskId),
    [overdueTasks, activeFocusTaskId],
  );
  const displayTodayTasks = useMemo(
    () => filterOutActiveFocusTask(todayTasks, activeFocusTaskId),
    [todayTasks, activeFocusTaskId],
  );
  const displayNextActions = useMemo(
    () => filterOutActiveFocusTask(nextActions || [], activeFocusTaskId),
    [nextActions, activeFocusTaskId],
  );
  const displayUpcomingTasks = useMemo(
    () => filterOutActiveFocusTask(upcomingTasks, activeFocusTaskId),
    [upcomingTasks, activeFocusTaskId],
  );

  return {
    topActionableTaskId,
    heroTask,
    displayOverdueTasks,
    displayTodayTasks,
    displayNextActions,
    displayUpcomingTasks,
  };
}

export function buildDailySectionDurations({
  todayTasks,
  completedTodayTasks,
  nextActions,
  overdueTasks,
  upcomingTasks,
  tasksMap,
}) {
  return {
    formattedTodayDuration: getDailySectionStats(todayTasks, tasksMap),
    formattedCompletedDuration: getDailySectionStats(
      completedTodayTasks,
      tasksMap,
    ),
    formattedNextActionsDuration: getDailySectionStats(
      nextActions || [],
      tasksMap,
    ),
    formattedOverdueDuration: getDailySectionStats(overdueTasks, tasksMap),
    formattedUpcomingDuration: getDailySectionStats(upcomingTasks, tasksMap),
  };
}
